export type FilterOptionId = number | string;

export type FilterOption = {
  id: FilterOptionId;
  name: string;
};

type FilterOptionGroupProps = {
  title: string;
  options: FilterOption[];
  activeIds: FilterOptionId[];
  disabledIds: FilterOptionId[];
  columns?: number;
  onToggle: (optionId: FilterOptionId) => void;
};

const FilterOptionGroup = ({
  title,
  options,
  activeIds,
  disabledIds,
  columns = 2,
  onToggle,
}: FilterOptionGroupProps) => (
  <div className="p-3">
    <h2 className="title-medium semi-bold mb-m">{title}</h2>
    <div
      className="grid text-center"
      style={{ '--bs-columns': columns, '--bs-gap': '8px' } as React.CSSProperties}
    >
      {options.map((option) => {
        const isActive = activeIds.includes(option.id);
        const isDisabled = disabledIds.includes(option.id);

        return (
          <button
            className={isActive ? 'filter-pill active' : 'filter-pill'}
            key={option.id}
            disabled={isDisabled}
            onClick={() => onToggle(option.id)}
          >
            {option.name}
          </button>
        );
      })}
    </div>
  </div>
);

export default FilterOptionGroup;
